import { Config } from "../../../assets/svg-icons";

export const INTEGRATION = {
  name: "Integration Hub",
  shortName: "IH",
  route: "/admin/integration",
  permissions: ["FLOWHUB_VIEW"],
  icon: Config,
  extraRoutes: [
    {
      route: "/admin/integration/components",
      permissions: ["FLOWHUB_VIEW"],
    },
    {
      route: "/admin/integration/pipelines/new",
      permissions: ["CREATE_FLOWHUB_PIPELINE"],
    },
    {
      route: "/admin/integration/pipelines/:id/edit",
      permissions: ["CREATE_FLOWHUB_PIPELINE"],
    },
    {
      route: "/admin/integration/pipelines/:id/executions",
      permissions: ["FLOWHUB_VIEW"],
    },
  ],
};
